/* NOTE: Actions to create,
* Opening modal to toggle flag
* Closing modal to toggle flag
* thunk to handle updating ticket mutation */

import { updateTicketMutationGQL } from './graphql';
import { getCurrentDepartmentId, getCurrentDistrictId } from '../../ticketApprovals/selectors';

export const types = {
  OPEN_TICKET_ENTRY_FORM: 'ticketEntryForm/OPEN_TICKET_ENTRY_FORM',
  CLOSE_TICKET_ENTRY_FORM: 'ticketEntryForm/CLOSE_TICKET_ENTRY_FORM',
  SET_TICKET_DETAILS: 'ticketEntryForm/SET_TICKET_DETAILS',
};

export const openTicketEntryForm = () => {
  return {
    type: types.OPEN_TICKET_ENTRY_FORM,
  };
};

export const closeTicketEntryForm = () => {
  return {
    type: types.CLOSE_TICKET_ENTRY_FORM,
  };
};

export const dispatchCreateUpdateTicket = (ticket, jobId) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const districtId = getCurrentDistrictId(state);
    const departmentId = getCurrentDepartmentId(state);
    await updateTicketMutationGQL(client, ticket, districtId, departmentId, jobId);
    dispatch(closeTicketEntryForm());
  };
};
